(() => {
  const initializeMagnifier = () => {
    let lens = document.querySelector('.mc-magnifier-lens');

    if (!lens) {
      lens = document.createElement('div');
      lens.className = 'mc-magnifier-lens';
      document.body.appendChild(lens);
    }

    const zoomLevel = 3;
    const lensOffset = 30;

    const hideLens = () => {
      lens.classList.remove('is-active');
      lens.style.backgroundImage = '';
    };

    document.addEventListener('mousemove', (event) => {
      if (window.innerWidth < 990) {
        hideLens();
        return;
      }

      const card = event.target.closest(
        '.collection .card-wrapper'
      );

      if (!card) {
        hideLens();
        return;
      }

      const media = card.querySelector('.card__media');
      const image = card.querySelector('.card__media img');

      if (!media || !image) {
        hideLens();
        return;
      }

      const rect = media.getBoundingClientRect();

      const isInsideMedia =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!isInsideMedia) {
        hideLens();
        return;
      }

      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      const xPercent = x / rect.width;
      const yPercent = y / rect.height;

      const imageUrl = image.currentSrc || image.src;

      lens.style.backgroundImage = `url("${imageUrl}")`;
      lens.style.backgroundSize =
        `${rect.width * zoomLevel}px ${rect.height * zoomLevel}px`;

      const backgroundX =
        -(xPercent * rect.width * zoomLevel - lens.offsetWidth / 2);

      const backgroundY =
        -(yPercent * rect.height * zoomLevel - lens.offsetHeight / 2);

      lens.style.backgroundPosition =
        `${backgroundX}px ${backgroundY}px`;

      let left = event.clientX + lensOffset;
      let top = event.clientY - lens.offsetHeight / 2;

      if (left + lens.offsetWidth > window.innerWidth - 12) {
        left = event.clientX - lens.offsetWidth - lensOffset;
      }

      top = Math.max(
        12,
        Math.min(
          top,
          window.innerHeight - lens.offsetHeight - 12
        )
      );

      lens.style.left = `${left}px`;
      lens.style.top = `${top}px`;
      lens.classList.add('is-active');
    });

    document.addEventListener('mouseleave', hideLens);
    window.addEventListener('scroll', hideLens, { passive: true });
    window.addEventListener('resize', hideLens);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeMagnifier,
      { once: true }
    );
  } else {
    initializeMagnifier();
  }
})();